export default {
	lang: 'ru',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav0": 'Учетная запись Безопасность',
		"nav1": 'Мой облачный диск',
		"nav2": 'Выйти',
		"nav3": 'Войти/Зарегистрироваться',
		"nav4": 'Можно записывать звонки и аудиоконтент на телефоне и преобразовывать их в текст. Для использования необходимо подключить наушники серии VTransBUDS.',
		"nav5": 'Отсканируйте код для загрузки',
		"nav6": 'Важная коммуникация, эффективный возврат',
		"speaker_not_null": 'Невозможно редактировать динамик, пуст!',
		"speaker": 'Динамик',
		"copy_success": 'Копирование выполнено успешно',
	},
	login: {
		"login1": 'Пароль входа',
		"login2": 'СМС-вход',
		"loginTab3": 'Электронная почта входа',
		"login3": 'Электронная почта',
		"login4": 'Пароль входа',
		"login5": 'Номер мобильного телефона',
		"login6": 'Пожалуйста, выберите',
		"login7": 'Код проверки мобильного телефона',
		"login8": 'Войти',
		"login9": 'Забыли пароль',
		"login10": 'Зарегистрироваться',
		"login11": 'Вход означает, что вы согласны',
		"login12": 'Соглашение об обслуживании',
		"login13": 'Соглашение о конфиденциальности',
		"login14": 'Получить',
		"login15": 'Китай',
		"login16": 'Пожалуйста, введите свой учетная запись',
		"login17": 'Введите пароль',
		"login18": 'Вход выполнен успешно!',
		"login19": 'Введите код подтверждения!',
		"login20": 'Отправлено успешно!',
		"login21": 'И',
		"login22": 'Облачный диск регистратора',
		"login23": 'Мои записи',
		"login24": 'Моя беседа',
		"login25": 'Безопасность учетной записи',
		"login26": 'Выйти',
		"login27": 'Восстановление пароля электронной почты',
		"login28": 'Электронная почта',
		"login29": 'Код подтверждения электронной почты',
		"login30": 'Установить пароль входа (6-16 символов)',
		"login31": 'Введите пароль входа еще раз',
		"login32": 'Отправить',
		"login33": 'Вернуться к входу',
		"login34": 'Изменение успешно выполнено!',
	},
	register: {
		"register1": 'Номер мобильного телефона',
		"register2": 'Пожалуйста, введите номер мобильного телефона',
		"register3": 'Пожалуйста, выберите',
		"register4": 'Код подтверждения мобильного телефона',
		"register5": 'Установить пароль',
		"register6": 'Пожалуйста, введите код подтверждения',
		"register7": '6-16 символов',
		"register8": 'Подтверждение пароля',
		"register9": 'Электронная почта',
		"register10": 'Пожалуйста, введите адрес электронной почты',
		"register11": 'Код подтверждения электронной почты',
		"register12": 'Пожалуйста, введите код подтверждения',
		"register13": 'Я прочитал и согласен',
		"register14": 'Пожалуйста, прочтите и проверьте соглашение',
		"register15": 'Неправильный формат номера мобильного телефона / Номер мобильного телефона был зарегистрирован',
		"register16": 'Неверный код подтверждения мобильного телефона',
		"register17": 'Введите адрес электронной почты / Ошибка формата адреса электронной почты',
		"register18": 'Ошибка формата адреса электронной почты',
		"register19": 'Ошибка кода подтверждения адреса электронной почты',
		"register20": 'Установите пароль длиной от 6 до 16 символов',
		"register21": 'Ошибка формата пароля',
		"register22": 'Два пароля несовместимы, введите его повторно',
		"register23": 'Введите пароль',
		"register24": 'Регистрация прошла успешно!',
		"register25": 'Ошибка кода подтверждения',
	},
	recorder: {
		"recorder1": 'Мой облачный диск',
		"recorder2": 'Емкость облачного пространства',
		"recorder3": 'Недавние файлы',
		"recorder331": 'Корзина',
		"recorder332": 'Удалить все',
		"recorder4": 'Имя',
		"recorder5": 'Длительность аудио',
		"recorder6": 'Размер файла',
		"recorder7": 'Время создания',
		"recorder8": 'Операция',
		"recorder9": 'Описание облачного пространства',
		"recorder10": 'Аудио',
		"recorder11": 'OCR-файл',
		"recorder12": '1. Для чего используется облачное пространство?',
		"recorder13": 'После записи на диктофон вы можете загрузить аудио и расшифрованные файлы в облачное пространство. Даже если диктофона нет с вами, вы можете войти в облачное пространство, чтобы просмотреть аудио.',
		"recorder14": '2. Как загрузить в облачное пространство?',
		"recorder15": 'Войдите в [Мои файлы] на диктофоне, выберите целевой файл и нажмите и удерживайте, чтобы отобразить опцию, нажмите «Загрузить», чтобы загрузить файл в облачное пространство.',
		"recorder16": '3. Как просматривать/управлять файлами облачного пространства?',
		"recorder17": 'Войдите на официальный сайт Beibo, выберите «My-Recorder Cloud Disk», и вы сможете просмотреть загруженные файлы диктофона. Вы можете выбрать целевой файл для загрузки, удаления и других операций. Вы можете очистить облачное хранилище, удалив облачные файлы!',
		"recorder18": 'Не транскрибировано',
		"recorder19": 'Просмотреть сводку',
		"recorder20": 'Спикер',
		"recorder21": 'Изменить имя спикера',
		"recorder22": 'Подтвердить',
		"recorder23": 'Загрузить',
		"recorder24": 'Загрузить контент:',
		"recorder25": 'Настройки загрузки:',
		"recorder26": 'Показать спикера',
		"recorder27": 'Отмена',
		"recorder28": 'Обмен ссылками',
		"recorder29": 'Любой, кто получит ссылку, сможет получить к ней доступ. Поддерживает только чтение. Ссылка действительна в течение 7 дней',
		"recorder30": 'Копировать ссылку',
		"recorder31": 'Сканировать и быстро просмотреть',
		"recorder32": 'Умная организация',
		"recorder33": 'Различайте говорящих',
		"recorder34": 'Интеллектуально различайте транскрибированные тексты в соответствии с ролями говорящих',
		"recorder35": 'Интеллектуальная регуляризация разговорной речи',
		"recorder36": 'Автоматически фильтровать модальные частицы, повторяющиеся слова и слова-паузы',
		"recorder37": 'Фильтрация нечеловеческого голоса',
		"recorder38": 'Автоматически пропускать аудио без человеческого голоса и шума во время воспроизведения',
		"recorder39": 'Пожалуйста, выберите',
		"recorder40": 'Документ',
		"recorder41": 'Аудио',
		"recorder42": 'Документ+Аудио',
		"recorder43":'Запрос',
		"recorder44":'Эта операция удалит файл. Продолжить?',
		"recorder441":'Эта операция удалит все файлы. Продолжить?',
		"recorder45":'ОК',
		"recorder46":'Отмена',
		"recorder47":'Удалено успешно!',
		"recorder48":'Удаление отменено',
		"recorder49":'Пока нет отметки',
		"recorder50":"Сохранение...",
		"recorder51":'Корзина',
	},
	personal: {
		"personal1": 'Настройки аккаунта',
		"personal2": 'Личная информация',
		"personal3": 'Аватар',
		"personal4": 'Загрузить файл',
		"personal5": 'Поддержка стилей JPG, JPEG, GIF, PNG, поддержка изображений размером до 2 М',
		"personal6": 'Псевдоним',
		"personal7": 'Пожалуйста, введите свой псевдоним',
		"personal8": 'Пол',
		"personal9": 'Г-н',
		"personal10": 'Г-жа',
		"personal11": 'Конфиденциально',
		"personal12": 'День рождения',
		"personal13": 'Пожалуйста, выберите дату рождения',
		"personal14": 'Род занятий',
		"personal15": 'Пожалуйста, выберите свой род занятий',
		"personal16": 'Пожалуйста, введите род занятий (необязательно)',
		"personal17": 'Страна',
		"personal18": 'Выберите страну',
		"personal19": 'Сохранить',
		"personal20": 'Личная информация',
		"personal21": 'Безопасность аккаунта',
		"personal22": 'Поддерживаются только фотографии в пределах 2M',
		"personal23": 'Загрузка прошла успешно!',
		"personal24": 'Изменение выполнено успешно!',
		"personal25": 'Безопасность аккаунта',
		"personal26": 'Пароль для входа',
		"personal27": 'Изменить',
		"personal28": 'Электронная почта',
		"personal29": 'Изменить',
		"personal30": 'Аннулирование аккаунта',
		"personal32": 'Вы уверены, что хотите аннулировать свой аккаунт?',
		"personal33": `После отмены весь контент в вашей учетной записи будет удален, пожалуйста, будьте осторожны. `,
		"personal34": 'Отмена',
		"personal35": 'Подтвердить',
		"personal36": 'Аутентификация',
		"personal37": 'Чтобы подтвердить, что это вы работаете, пожалуйста, пройдите проверку личности с помощью кода проверки электронной почты',
		"personal38": 'Электронная почта',
		"personal39": 'Код проверки',
		"personal40": 'Пожалуйста, введите код проверки',
		"personal41": 'Далее',
		"personal42": 'Установить новый адрес электронной почты',
		"personal43": 'Электронная почта',
		"personal44": 'Пожалуйста, введите новый адрес электронной почты',
		"personal45": 'Код проверки',
		"personal46": 'Пожалуйста, введите код проверки',
		"personal47": 'Подтвердить',
		"personal48": 'Установить новый логин пароль',
		"personal49": 'Новый пароль для входа',
		"personal50": 'Пожалуйста, введите новый пароль',
		"personal51": 'Подтвердите новый пароль',
		"personal52": 'Пожалуйста, введите новый пароль еще раз',
		"personal53": 'Подтвердите',
		"personal54": 'Получить',
		"personal55": 'Ошибка формата электронной почты',
		"personal56": 'Изменено успешно!',
		"personal57": 'Пожалуйста, установите пароль длиной 6-16 символов',
		"personal58": 'Два введенных пароля несовместимы',
		"personal59": 'Изменено успешно!',
		"personal60": 'Выход из системы выполнен успешно!',
		"share_url": "Ссылка для общего доступа",
		"share_url_7_day": "Ссылка для общего доступа действительна в течение 7 дней. До истечения срока действия доступ к ней получит любой, кто получит ссылку.",
		"share_audio": "Аудиозапись",
		"share_trans_text": "Транскрипция",
		"share_summny_text": "Краткое содержание",
		"share_map": "Ментальная карта",
		"share_url_pw": "Шифрование доступа",
		"share_random_pw": "Пароль сгенерирован случайным образом",
		"share_url_copy": "Копировать ссылку",
		"share_link_pw": "Пароль доступа",
		"share_copy_success": "Копирование выполнено успешно!",
		"share_speaker": "Выступающий",
		"share_no_update_speaker": "Невозможно изменить Выступающий пусто",
		"share_no_trans":"Нет транскрипции",
		"share_no_summny":"Нет краткого содержания",
		"share_no_map":"Нет содержимого карты",
		"share_trans_text_1": "Транскрипция",
		"share_summny_text_1": "Краткое содержание",
		"share_map_1": "Карта",
		"share_save": "Сохранить успешно",
		"share_no_map":"Изображение карты не создано",
		"share_update_text": "Изменить текст транскрипции",
		"share_update_text2": "Редактировать текст резюме",
		"showLoading": "загрузка...",
	}
}